<template>
    <div v-if="cert_data != null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center>
            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>
        <template>
            <!-- {{ cert_data }} -->
            <!-- {{data_list[0]}} -->
            <div v-if="show == true" class="certDiv"
                style="margin-left: 15%; margin-right: 15%; background-color: white">
                <div style="padding: 20px; padding-top: 130px">
                    <v-row>
                        <v-col cols="12" sm="3" md="3" align="right">
                            <img class="logo" :src="org_basic_data.school_logo" width="160" height="110" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8" align="center">
                            <h1>{{ org_basic_data.school_name }}</h1>
                            <h2 style="text-decoration: underline">Bonafide Certificate</h2>
                            <div class="pt-5 subLine" style="font-size: 20px">
                                To whom so ever it may concern
                            </div>
                        </v-col>
                    </v-row>
                    <br />
                    <div>
                        <p style="padding-left: 75px">This is to certify that :-</p>
                        <div style="margin-left: 15px; margin-right: 15px">
                            <table class="cert-table" style="">
                                <tr>
                                    <td>Miss / Master -</td>
                                    <td>{{ cert_data.stud_name }}</td>
                                </tr>
                                <tr>
                                    <td>Is/was studying in our school in std.</td>
                                    <td>{{ cert_data.std }}</td>
                                </tr>
                                <tr>
                                    <td>Since June -</td>
                                    <td>{{ cert_data.ay }}</td>
                                </tr>
                                <tr>
                                    <td>As per our General Register No. -</td>
                                    <td>{{ prno }}</td>
                                </tr>
                                <tr>
                                    <td>His / her Mother's Name -</td>
                                    <td>{{ cert_data.mother_name }}</td>
                                </tr>
                                <tr>
                                    <td>Nationality is -</td>
                                    <td>{{ cert_data.nationality }}</td>
                                </tr>
                                <tr>
                                    <td>Religion and Caste is -</td>
                                    <td>
                                        {{ cert_data.religion }} &nbsp;&nbsp; {{ cert_data.caste }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Place of Birth is -</td>
                                    <td>{{ cert_data.place_of_birth }}</td>
                                </tr>
                                <tr>
                                    <td>Date of Birth is -</td>
                                    <td>{{ cert_data.dob }}</td>
                                </tr>
                                <tr>
                                    <td>Reason -</td>
                                    <td>{{ reason }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="pt-10" style="padding-left: 70px">
                            <p>Date : {{ cert_data.cert_date }}</p>
                        </div>
                        <div class="pt-6" style="padding-left: 70px">
                            <p>Place : {{ cert_data.Place }}</p>
                        </div>
                    </div>
                    <div style="height: 240px"></div>
                </div>
            </div>
            <br /><br /><br />
            <v-card class="box no-display">
                <div class="no-display">
                    <center><span>------- Modify -------</span></center>
                    <v-row>
                        <v-col cols="12" sm="4" md="4">
                            <v-text-field style="margin-left: 77px" label="Reason" v-model="reason"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="4" align="center">
                            <v-btn class="info" @click="saveData">Save</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            fetch_loader: false,
            gen_cert_loader: false,
            show_cert_loader: false,
            search: "",
            dialog: false,
            awspath: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            data_list: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            cert_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            show: true,
            reason: "",
            prno: "",
            org_basic_data: [],
            htmlToPdfOptions: {
                margin: 0,

                filename: `document.pdf`,

                image: {
                    type: "jpeg",
                    quality: 0.98,
                },

                enableLinks: false,

                html2canvas: {
                    scale: 1,
                    useCORS: true,
                },

                jsPDF: {
                    unit: "in",
                    format: "a4",
                    orientation: "landscape",
                },
            },
            progress: 0,
        };
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    components: {
        VueHtml2pdf,
        // "pdf-content": PdfContent,
    },
    methods: {
        saveData() {
            // alert("Into the method");
            if (!this.reason) {
                this.showSnackbar("red", "Please enter reason");
                return;
            }
            const formData = {
                reason: this.reason,
                certificate_id: this.cert_data.cert_id,
            };
            console.log("formData", formData);

            axios
                .post("/icard/saveBonafideRemark", formData)
                .then((res) => {
                    // alert("into post");
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        // alert("Into flag yes");
                        this.showSnackbar("success", "Data saved successfully");
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.Message);
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        makePDF() {
            window.html2canvas = html2canvas;
            var doc = new jsPDF("l", "pt", "a4");
            doc.html(document.querySelector("#app"), {
                callback: function (pdf) {
                    pdf.save("mypdf.pdf");
                },
            });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        close() {
            this.$router.push({ name: "get-Certificate-Report", target: "blank" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.cert_data = JSON.parse(localStorage.getItem("cert_data"));
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
            this.prno = JSON.parse(localStorage.getItem("prno"));
            this.reason = JSON.parse(localStorage.getItem("reason"));

        },
        async exportToPDF() {
            console.log("hi");
            await html2pdf(this.$refs.document, {
                enableLinks: false,
                margin: 0,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 1, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            });
            console.log("hi1");
        },
        generateReport() {
            this.beforeDownload();
            this.$refs.html2Pdf.generatePdf();
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text(
                            "Page " + i + " of " + totalPages,
                            pdf.internal.pageSize.getWidth() * 0.88,
                            pdf.internal.pageSize.getHeight() - 0.3
                        );
                    }
                })
                .save();
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.data_list = JSON.parse(localStorage.getItem("data_list"));
        this.onload();
    },
};
</script>
<style scoped>
.cert-table,
tr,
td {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 10px;
}

.cert-table {
    width: 90%;
    margin-left: 60px;
    margin-right: 20px;
}

.cert-table td:first-child {
    width: 50% !important;
}

.logo {
    margin-right: -60px;
    margin-top: 24px;
}

.subLine {
    font-size: 20px;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        /* size: 25.5in 19in; */
        size: 13.5in 16.5in !important;
    }

    .certDiv {
        margin-left: 0 !important;
        margin-right: 0 !important;
        font-size: 26px !important;
        margin-top: -90px !important;
        margin-bottom: -100px !important;
    }

    .logo {
        width: 250px !important;
        height: 170px !important;
        /* margin-right: 0px !important; */
        margin-top: 20px !important;
    }

    .subLine {
        font-size: 30px !important;
    }
}
</style>